(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["characters-landing"]) return;
  try {
    
(()=>{const film=document.getElementById('film');
if(!film)return;
const play=document.getElementById('play');
film.muted=true;
function reflect(){play.textContent=film.paused?play.dataset.play:play.dataset.pause;play.setAttribute('aria-label',play.textContent)}
play.addEventListener('click',()=>{if(film.paused){film.play().catch(()=>reflect())}else{film.pause()}});
film.addEventListener('play',reflect);film.addEventListener('pause',reflect);
if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){film.autoplay=true;film.play().catch(()=>reflect())}
document.addEventListener('visibilitychange',()=>{if(document.hidden)film.pause()});
})();

  } catch(e) { console.error(e); }
})();
})();
